import { TaskParamType } from "src/types/workflow.types";

export const ColorForHandle: Record<TaskParamType, string> = {
  BROWSER_INSTANCE: "#0ea5e9",
  STRING: "#f59e0b",
};
